import React from 'react';
import styles from './Avatar.module.scss';

interface AvatarProps {
    imageUrl?: string;
    className?: string;
    initials?: string;
}

export const Avatar: React.FC<AvatarProps> = ({ imageUrl, className, initials }) => {
    return <div className={`${styles.avatar} ${className}`}>
            {imageUrl ? <img src={imageUrl} alt="Avatar" /> : <div className={styles.avatarInitials}>{initials}</div>}
        </div>;
};